import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';



@Component({
  selector: 'app-modal-dataset',
  templateUrl: './modal-dataset.component.html',
  styleUrls: ['./modal-dataset.component.scss']
})
export class ModalDatasetComponent implements OnInit {
  
  @Input() dataset;
  @Input() empresa;
  datasetDeEmpresa=[]


  viewPie=[700,300]
  colorScheme = {
    domain: ['#F94144', '#F3722C', '#F8961E', '#F9C74F','#90BE6D','#43AA8B','#577590']
  };
  gradientPie: boolean = false;
  showLegendPie: boolean = false;
  legendPositionPie="below"
  showLabelsPie=true
  isDoughnutPie=true 
  trimLabelsPie=false 
 
  yAxisLabel: string = 'Status';
  showYAxisLabel: boolean = true;
  xAxisLabel: string = 'Número de permisos';

  totalTrabajadores=0
  totalPTW=0
  tickets=''

  dataChart = [
    {
      "name": "W en alturas ",
      "value": 1,
    },
    {
      "name": "W en caliente",
      "value": 1,
    },
    {
      "name": "Levantamiento mecánico",
      "value": 1,
    },
    {
      "name": "Energías peligrosas",
      "value": 1,
    },
    {
      "name": "Confinados",
      "value": 1,
    },
    {
      "name": "Hazmat",
      "value": 1,
    },
    {
      "name": "Sup. y monitoreo",
      "value": 1,
    },
    {
      "name": "Otros",
      "value": 1,
    },
  ];

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.organizaDataset()
  }

  organizaDataset(){
    console.log("organiza dataset activado")
    this.dataset.forEach((element) => {


      if(element.empresa == this.empresa){

        this.totalTrabajadores = element.totalTrabajadores
        this.totalPTW= element.totalPTWS
        this.tickets=element.tickets

        this.dataChart[0].value = element.alturas
        this.dataChart[0].name="Alturas: "+element.alturas

        this.dataChart[1].value = element.calientes
        this.dataChart[1].name="Caliente: "+element.calientes

        this.dataChart[2].value = element.energias
        this.dataChart[2].name="Energías: "+element.energias

        this.dataChart[3].value = element.confinados
        this.dataChart[3].name="Confinados: "+element.confinados

        this.dataChart[4].value = element.levantamiento
        this.dataChart[4].name="Levantam: "+element.levantamiento

        this.dataChart[5].value = element.hazmat
        this.dataChart[5].name="Hazmat: "+element.hazmat

        this.dataChart[6].value = element.supervision
        this.dataChart[6].name="Superv: "+element.supervision

        this.dataChart[7].value = element.otros
        this.dataChart[7].name="Otros: "+element.otros

      }
    });
  }



  

}
